/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { getSyndicationId } from "application/utils";
import { Auth } from "aws-amplify";
import axios from "axios";
import { signOut } from "redux/Auth/actions";
import { enqueueSnackbar as enqueueSnackbarAction } from "redux/Notifications/reducer";
import store from "redux/store";

const logOut = () => {
  const authorized = store.getState()?.auth?.authorized;

  if (authorized) {
    store.dispatch(
      enqueueSnackbarAction({
        message: "Authorization is expired!",
        options: { variant: "error", key: "auth-expired" },
      })
    );
    store.dispatch(signOut());
  }
};

const getBaseUrl = (): string => {
  switch (process.env.REACT_APP_ENV) {
    case "local":
      return "http://localhost:5000";
    case "stage":
      return "https://stage.api.emerge9.com";
    case "prod":
      return "https://prod.api.emerge9.com";
    default:
      return "https://dev.api.emerge9.com";
  }
};

const getSyndicationHeaders = () => {
  const syndicationId = getSyndicationId();

  if (!syndicationId) {
    return {} as any;
  }

  return { "partner-id": syndicationId };
};

export const apiClient = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    "Access-Control-Allow-Origin": "localhost:3000",
    ...getSyndicationHeaders(),
  },
});

apiClient.interceptors.request.use(function (config) {
  return new Promise((resolve) => {
    Auth.currentSession()
      .then((session) => {
        const idTokenExpire = session.getIdToken().getExpiration() * 1000;
        const refreshToken = session.getRefreshToken();
        const currentTimeSeconds = Math.round(+new Date());
        const rememberMe = localStorage.getItem("rememberMe");
        if (idTokenExpire < currentTimeSeconds) {
          if (rememberMe) {
            Auth.currentAuthenticatedUser().then((res) => {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              res.refreshSession(refreshToken, (err: Error, data: any) => {
                if (err) {
                  logOut();
                } else {
                  config!.headers!.Authorization =
                    "Bearer " + data.getIdToken().getJwtToken();
                  resolve(config);
                }
              });
            });
          } else {
            logOut();
          }
        } else {
          config!.headers!.Authorization =
            "Bearer " + session.getIdToken().getJwtToken();
          resolve(config);
        }
      })
      .catch(() => {
        // No logged-in user: don't set auth header
        resolve(config);
      });
  });
});

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const isTokenExpired =
      error.response.status === 401 &&
      error?.response?.data?.err?.msg === "Token expired";

    if (isTokenExpired) {
      logOut();
    }

    throw error;
  }
);
